import React from 'react';
import Navbar from '../Components/Navbar'
import logotipo from '../Assets/logoNavbar.jpg'
import Cabezera from '../Components/Cabezera'
import Anuncio from '../Components/Anuncio'
import Servicios from '../Components/Servicios'
import servicio1 from '../Assets/servicios/coach_monochromatic.png'
import servicio2 from '../Assets/servicios/recycling.png'
import servicio3 from '../Assets/servicios/data_analytics__monochromatic.png'
import Pie from '../Components/Piepagina'
import '../Styles/Inicio.css'
import GaleriaFundas from '../Components/GaleriaFundas';
import GaleriaEnvases from '../Components/GaleriaEnvases';
import GaleriaCajas from '../Components/GaleriaCajas.jsx';
import GaleriaRecipientes from '../Components/GaleriaRecipientes.jsx';
import Contactos from '../Components/Contactos';

 
const Inicio = () => {
    return ( 
        <div className="P-Inicio" >
            <div className= "Navbar"> <Navbar icon = {logotipo}/></div>
            <Cabezera />
            <Anuncio
                title1 = "MISION"
                text1 = "Apoyar a nuestros clientes con productos nuevos elaborados con materia prima 
                biodegradable y/o reciclable aportando al cuidado de nuestro planeta."
                
            />
            <div className = "servicio" id="SERVICIOS" >
                <Servicios
                    title = "Cumplimos Normativas"
                    text = "Respetar nuestras obligaciones contractuales y con el estado.  "
                    imagen =  {servicio1}
                />
                <Servicios
                    title = "Ayudamos al Medio Ambiente"
                    text = "Evaluar los efectos de los productos en el bienestar de las personas
                     a las que van destinados y en el medio ambiente "
                    imagen =  {servicio2}
                />
                <Servicios
                    title = "Calidad e Innovación"
                    text = "Nuestras acciones se fundamentan en integridad, honestidad ética e
                    innovación, calidad y pasión por lo que hacemos
                     "
                    imagen =  {servicio3}
                />
            </div>
            <Anuncio 
                title1="VISION"
                text1 = "Ser reconocidos en el mercado ecuatoriano como una empresa comprometida con el
                 medio ambiente y generando productos de calidad y rentabilidad,
                  dando soluciones a las expectativas de nuestros clientes."
            />
            <GaleriaFundas/>
            <GaleriaEnvases/>
            <GaleriaCajas/>
            <GaleriaRecipientes/>
            <Contactos/>
            <Pie/>
        </div>
        
     );
}
 
export default Inicio;